import {isObject} from '~shared/utils';

import {isUndefined} from '~ui/utils';

export const prepareJsonPatch = (data: object): string => {
    return JSON.stringify(prepareJsonPatchInner(data, ''));
};

const prepareJsonPatchInner = (data: object, parentPath: string): object[] => {
    const patches = Object.entries(data).reduce((result: object[], [key, value]) => {
        const path = `${parentPath}/${key}`;
        if (isUndefined(value)) return result;

        if (isObject(value)) {
            result.push({
                op: 'add',
                path,
                value: Array.isArray(value) ? [] : {},
            });

            return result.concat(prepareJsonPatchInner(value, path));
        }

        result.push({
            op: 'add',
            path,
            value,
        });

        return result;
    }, []);
    return patches;
};
